// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SelectOption = styled.div`
  display: flex;
  align-items: center;
`;
SelectOption.displayName = 'S.SelectOption';

export const SelectOptionLabel = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
`;
SelectOptionLabel.displayName = 'S.SelectOptionLabel';

export const SelectOptionLabelText = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
`;
SelectOptionLabelText.displayName = 'S.SelectOptionLabelText';

export const SelectOptionIcon = styled(Icon)`
  margin-right: 8px;
`;
SelectOptionIcon.displayName = 'S.SelectOptionIcon';
